import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface CreatorTagProps {
  create_username: string;
  isNameFull?: boolean;
}

export default function CreatorTag({
  create_username,
  isNameFull,
}: CreatorTagProps) {
  return <TagName isNameFull={isNameFull}>@ {create_username}</TagName>;
}

const TagName = styled.div<Pick<CreatorTagProps, 'isNameFull'>>`
  ${({ theme, isNameFull }) => css`
    display: block;
    flex-shrink: 0;
    width: fit-content;
    ${!isNameFull && 'max-width: 100px'};
    padding: 2px 8px;
    border-radius: 11px;
    background: ${theme.backgroundColor.bg_dark_5_alpha};
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
    color: ${theme.content.content_light_1};
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);
    word-break: keep-all;
    backdrop-filter: blur(5px);
    ${theme.mixins.text.ellipsis_1};
    ${theme.fontStyle.text.caption_medium};
  `}
`;
